export class PropertyEffect {
    public id: string;
    public name: string;
    public type: string;
    public value: any;
}
